import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FormProvider } from "./context/FormContext";
import Home from "./Home";
import AboutPage from "./components/AboutPage";
import BranchesPage from "./components/BranchesPage";
import BranchPage from "./components/BranchPage";
import NewsEventsPage from "./components/NewsEventsPage";
import CoursesPage from "./components/CoursesPage";
import CourseDetailPage from "./components/CourseDetailPage";
import ContactUsPage from "./components/ContactUsPage";
import CareersPage from "./components/CareersPage";
import TestimonialsPage from "./components/TestimonialsPage";
import AdminDashboard from "./components/AdminDashboard";
import Login from "./components/Login";
import RequireAuth from "./components/RequireAuth";
import SplashScreen from "./components/SplashScreen";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Preload any necessary resources here
    // For now, we'll just show the splash screen for a few seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); // Show splash screen for 2.5 seconds

    return () => clearTimeout(timer);
  }, []);
  return (
    <FormProvider>
      {loading ? (
        <SplashScreen onFinish={() => setLoading(false)} />
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/course/:courseId" element={<CourseDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/news-events" element={<NewsEventsPage />} />
            <Route path="/branches" element={<BranchesPage />} />
            <Route path="/branch/:branchId" element={<BranchPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
          </Routes>
        </BrowserRouter>
      )}
    </FormProvider>
  );
}

export default App;
